export const AttendanceActionTypes = {
  FETCH_ATTENDANCE_START: "FETCH_ATTENDANCE_START",
  FETCH_ATTENDANCE_SUCCESS: "FETCH_ATTENDANCE_SUCCESS",
  FETCH_ATTENDANCE_FAILURE: "FETCH_ATTENDANCE_FAILURE",
  FETCH_ATTENDANCE_CHANGED: "FETCH_ATTENDANCE_CHANGED",
  ATTENDANCE_RESET: "ATTENDANCE_RESET",

  UPDATE_ATTENDANCE_START: "UPDATE_ATTENDANCE_START",
  UPDATE_ATTENDANCE_SUCCESS: "UPDATE_ATTENDANCE_SUCCESS",
  UPDATE_ATTENDANCE_FAILURE: "UPDATE_ATTENDANCE_FAILURE",
  UPDATE_ATTENDANCE_CHANGED: "UPDATE_ATTENDANCE_CHANGED",
  UPDATE_ATTENDANCE_RESET: "UPDATE_ATTENDANCE_RESET",

  FETCH_ATTENDANCE_DOWNLOAD_DETAILS_START:
    "FETCH_ATTENDANCE_DOWNLOAD_DETAILS_START",
  FETCH_ATTENDANCE_DOWNLOAD_DETAILS_SUCCESS:
    "FETCH_ATTENDANCE_DOWNLOAD_DETAILS_SUCCESS",
  FETCH_ATTENDANCE_DOWNLOAD_DETAILS_FAILURE:
    "FETCH_ATTENDANCE_DOWNLOAD_DETAILS_FAILURE",
  FETCH_ATTENDANCE_DOWNLOAD_DETAILS_CHANGED:
    "FETCH_ATTENDANCE_DOWNLOAD_DETAILS_CHANGED",
  FETCH_ATTENDANCE_DOWNLOAD_DETAIL_RESET:
    "FETCH_ATTENDANCE_DOWNLOAD_DETAIL_RESET",

  ATTENDANCE_EXPORT_START: "attendance_export_start",
  ATTENDANCE_EXPORT_SUCCESS: "attendance_export_success",
  ATTENDANCE_EXPORT_FAILURE: "attendance_export_failure",
  ATTENDANCE_EXPORT_RESET_START: "attendance_export_reset_start",
  ATTENDANCE_EXPORT_CHANGED: "attendance_export_changed",
};
